import { render, staticRenderFns } from "./ItemListSideMenu.vue?vue&type=template&id=71687939&scoped=true"
import script from "./ItemListSideMenu.vue?vue&type=script&lang=js"
export * from "./ItemListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./ItemListSideMenu.vue?vue&type=style&index=0&id=71687939&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71687939",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71687939')) {
      api.createRecord('71687939', component.options)
    } else {
      api.reload('71687939', component.options)
    }
    module.hot.accept("./ItemListSideMenu.vue?vue&type=template&id=71687939&scoped=true", function () {
      api.rerender('71687939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemListSideMenu.vue"
export default component.exports